import React from 'react';
import {
  Box,
  FormLabel,
  CheckboxGroup,
  Stack,
  Checkbox,
  FormErrorMessage,
  FormControl
} from '@chakra-ui/react';
import { Controller, Control, FieldValues } from 'react-hook-form';

interface CheckboxGroupComponentProps {
  name: string;
  control: Control<FieldValues>;
  questionText: string;
  items: { answerValue: string; text: string }[];
  rules?: any;
  error?: any;
  onChecked?: (value: any[], name: string) => void;
}

const CheckboxGroupComponent: React.FC<CheckboxGroupComponentProps> = ({
  name,
  control,
  questionText,
  items,
  rules,
  error,
  onChecked
}) => {
  return (
    <FormControl isInvalid={!!error}>
      <Box alignItems="flex-start" mb="15px">
        <FormLabel
          fontWeight={400}
          p={['0 0 5px 0', '0']}
          w="100%"
          color="brand.fontColors.primary"
        >
          {questionText}
        </FormLabel>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ value, onChange, onBlur }) => {
            const safeValue = Array.isArray(value) ? value : []; 
            return (
              <>
                <CheckboxGroup value={safeValue} onChange={(val) => {
                  onChange(val);
                  if (onChecked) {
                    onChecked(val, name) // Convert Set to Array
                  }}
                }
              >
                  <Stack spacing={[1, 1]} direction={['column', 'column']}>
                    {items.map(item => (
                      <Checkbox
                        iconColor="#0092B0"
                        size="lg"
                        color="#888888"
                        id={item.answerValue}
                        key={item.answerValue}
                        value={item.answerValue}
                        onBlur={onBlur}
                      >
                        {item.text}
                      </Checkbox>
                    ))}
                  </Stack>
                </CheckboxGroup>
                <FormErrorMessage>{error?.message}</FormErrorMessage>
              </>
            )}}
        />
      </Box>
    </FormControl>
  );
};

export default CheckboxGroupComponent;